import axios from "axios";
import React, { useState } from "react";
import { FiLock, FiCheckCircle, FiXCircle } from "react-icons/fi";

const ResetPassword = () => {
	const [currentPassword, setCurrentPassword] = useState("");
	const [newPassword, setNewPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [message, setMessage] = useState("");

	const email = sessionStorage.getItem("email");

	const handlePasswordReset = async (e) => {
		e.preventDefault();

		if (newPassword !== confirmPassword) {
			setMessage("New password and confirm password do not match.");
			return;
		}

		try {
			const { data } = await axios.post(
				"https://ecobank.approot.ng/reset_password.php",
				{ currentPassword, newPassword, email }
			);

			setMessage(data.message);
			if (data.status !== "error") {
				setCurrentPassword("");
				setNewPassword("");
				setConfirmPassword("");
			}
		} catch (error) {
			setMessage("An unexpected error occurred. Please try again.");
			console.error(error);
		}
	};

	const isSuccess = message.toLowerCase().includes("success");

	return (
		<div className='min-h-screen bg-gradient-to-br from-white to-blue-50 flex items-center justify-center px-4'>
			<div className='w-full max-w-md p-8 bg-white rounded-xl shadow-xl border'>
				<h2 className='text-2xl font-bold text-gray-800 mb-6 text-center'>
					🔐 Reset Your Password
				</h2>

				<form onSubmit={handlePasswordReset} className='space-y-5'>
					{[
						{
							label: "Current Password",
							id: "currentPassword",
							value: currentPassword,
							onChange: setCurrentPassword,
						},
						{
							label: "New Password",
							id: "newPassword",
							value: newPassword,
							onChange: setNewPassword,
						},
						{
							label: "Confirm New Password",
							id: "confirmPassword",
							value: confirmPassword,
							onChange: setConfirmPassword,
						},
					].map(({ label, id, value, onChange }) => (
						<div key={id}>
							<label
								htmlFor={id}
								className='block mb-1 text-sm font-medium text-gray-700'
							>
								{label}
							</label>
							<div className='relative'>
								<FiLock className='absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400' />
								<input
									type='password'
									id={id}
									value={value}
									onChange={(e) => onChange(e.target.value)}
									required
									className='w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400 transition-all'
								/>
							</div>
						</div>
					))}

					<button
						type='submit'
						className='w-full bg-blue-600 text-white py-2.5 rounded-md font-semibold hover:bg-blue-700 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300'
					>
						Reset Password
					</button>

					{message && (
						<div
							className={`mt-4 px-4 py-3 rounded-md flex items-center justify-center text-sm gap-2 font-medium animate-fade-in ${
								isSuccess
									? "bg-green-100 text-green-700 border border-green-300"
									: "bg-red-100 text-red-700 border border-red-300"
							}`}
						>
							{isSuccess ? <FiCheckCircle /> : <FiXCircle />}
							{message}
						</div>
					)}
				</form>
			</div>
		</div>
	);
};

export default ResetPassword;
